export default __webpack_public_path__ + "static/media/1art.33a97f8f.svg";